import { render, staticRenderFns } from "./CreateSGStreams.vue?vue&type=template&id=d8f563d2"
import script from "./CreateSGStreams.vue?vue&type=script&lang=js"
export * from "./CreateSGStreams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports